<template>
  <div class="context-menu-btn-component">
    <VButton
      ref="button"
      :class="buttonClasses"
      :style="buttonStyle"
      :theme="theme"
      :disabled="disabled"
      @click="updateVisible(!visibleLocal)"
      @dblclick.stop
    >
      <template #icon>
        <VIcon
          :class="{ 'priority': hasPriority }"
          :material="icon"
          :theme="iconTheme"
        />
      </template>
    </VButton>

    <VPopup
      ref="popup"
      :target="target"
      :visible="visibleLocal"
      :offset="offset"
      :align="align"
      :class="$attrs.class"
      class="context-menu-btn-popup"
      @update:visible="updateVisible"
      @click="onContentClick"
    >
      <slot />
    </VPopup>
  </div>
</template>

<style lang="scss" src="./VContextMenuButton.scss"/>

<script lang="ts">
export default defineComponent({
	name: 'VContextMenuButton',

  inheritAttrs: false, // чтобы class не вешался на корневой div

  props: {
		visible: {
			type:    Boolean,
			default: false,
		},
		theme: {
			type:    String,
			default: 'flat',
		},
		icon: {
			type:    String,
			default: 'more_vert',
		},
		iconTheme: {
			type:    String,
			default: null,
		},
		align: {
			type:    String,
			default: 'right',
		},
		offset: {
			type:    Number,
			default: 0,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},

		buttonStyle: {
			type: Object,
		},
		hasPriority: {
			type:    Boolean,
			default: false,
		}
	},

	emits: ['update:visible'],

	data() {
		return {
			visibleLocal: this.visible || false,
			target:       null,
		};
	},

	computed: {
		buttonClasses() {
			return {
				'context-menu-btn': true,
				active:             this.visibleLocal,
			};
		},
	},

	watch: {
		visible(newVal) {
			this.visibleLocal = newVal;
		},
	},

	mounted() {
		this.target = this.$refs.button.$el;

		window.addEventListener('resize', this.resizer);
	},

	beforeUnmount() {
		window.removeEventListener('resize', this.resizer);
	},

	methods: {
		updateVisible(value) {
			this.visibleLocal = value;
			this.$emit('update:visible', this.visibleLocal);
		},

		resizer() {
			this.$refs.popup.calculatePosition();
		},

    // После любого клика на пункт меню мы закрываем меню, мы больше не пишем бесконечные дебильные emit('hide')
    onContentClick() {
      this.updateVisible(false);
    }
	},
});
</script>

